<template>
  <a-form
    class="mod-form"
    layout="horizontal"
    labelAlign="left"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :colon="false"
    :form="form"
    @submit="onSubmit"
  >
    <a-form-item label="原始密码" v-if="event === 0">
      <a-input
        size="large"
        placeholder="请输入原始密码"
        type="password"
        v-decorator="[
          'oldPassword',
          {
            rules: [
              {
                validator: handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]"
      >
      </a-input>
    </a-form-item>
    <a-form-item label="新密码">
      <a-input
        size="large"
        placeholder="请输入8-15位数字和字母组合的新密码"
        type="password"
        v-decorator="[
          'password',
          {
            rules: [
              {
                validator: handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]"
      >
      </a-input>
    </a-form-item>
    <a-form-item label="确认密码">
      <a-input
        size="large"
        placeholder="请再次输入新密码"
        type="password"
        v-decorator="[
          'confirmPassword',
          {
            rules: [
              {
                validator: handleFieldValidate
              }
            ],
            validateTrigger: 'blur'
          }
        ]"
      >
      </a-input>
    </a-form-item>
    <a-form-item label="验证码">
      <user-slider-captcha ref="verify" size="large" @change="onCaptchVerify">
      </user-slider-captcha>
    </a-form-item>
    <a-form-item :wrapper-col="wrapperColOffset">
      <a-button style="margin: 0; width: 100%" :loading="loading" type="primary" size="large" html-type="submit">提交修改</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import { validate } from '@/utils/validate'
import { changePassword, changeLoginPassword } from '@/api/member'

export default {
  props: {
    event: {
      type: Number,
      default: 0
    },
    realNameToken: String,
    type: String,
    loginName: String,
    cid: String
  },
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 19
      },
      wrapperColOffset: {
        span: 19, offset: 5
      },
      form: this.$form.createForm(this),
      token: '',
      loading: false
    }
  },
  methods: {
    handleFieldValidate (rule, value, callback) {
      validate('password-change', this.form.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    onSubmit (e) {
      e.preventDefault()

      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          try {
            const { token, event, realNameToken, loginName, cid } = this

            if (!token) {
              this.$error({
                content: '请拖动滑块完成验证！',
                centered: true
              })
              return
            }

            this.loading = true

            let params = {}
            let requestApi = changePassword
            if (this.type === 'newChange') {
              params = {
                cid: cid || undefined,
                loginName: loginName || undefined,
                oldPass: event === 0 ? values.oldPassword : undefined,
                newPass: values.password,
                sliderCaptCha: token
              }

              requestApi = changeLoginPassword
            } else {
              params = {
                newPwd: values.password,
                type: event,
                sliderCaptCha: token
              }

              if (event === 1) {
                params.realNameToken = realNameToken
              } else {
                params.oldPwd = values.oldPassword
              }
            }

            await requestApi(params)

            this.$success({
              content: '修改密码成功，请重新登录！',
              centered: true,
              onOk: () => {
                if (event === 1) {
                  this.$emit('next')
                } else {
                  this.$router.replace({
                    path: '/login',
                    query: {
                      __done__: '/micro/user/account'
                    }
                  })
                }
              }
            })
          } catch (err) {
            this.$refs.verify.refresh()

            if (err.code === 100010113) {
              this.$error({
                content: err.message,
                centered: true,
                onOk: () => {
                  this.$router.replace({
                    path: '/login',
                    query: {
                      __done__: '/micro/user/account'
                    }
                  })
                }
              })
            } else {
              this.$error({
                content: err.message,
                centered: true
              })
            }

            this.loading = false
          }
        }
      })
    },
    onCaptchVerify (value) {
      this.token = value
    }
  }
}
</script>
